<template>
  <div class="cash-chart-container">
    <h4 class="heading">{{ $t("cash") }}</h4>
    <div class="cash-chart">
      <div class="cash-chart__preloader" v-if="getMoneyDataLoading">
        <spinner :animation-duration="1000" :size="60" :color="'#2E79EF'" />
      </div>
      <pie-amchart
        v-else
        :data="reformat_cash_data"
        :total="$formatMoney(cash_data.totalAmount)"
        :currency="cash_data.currencySign"
        class="pie-chart"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { HalfCircleSpinner } from "epic-spinners";
import { balanceInCurrency, formatMoney } from "@/helpers/money";
import PieAmchart from "@/components/ui-kit/PieAmchart.vue";

export default {
  components: {
    spinner: HalfCircleSpinner,
    "pie-amchart": PieAmchart
  },
  computed: {
    // Данные для графика ...
    reformat_cash_data() {
      return (
        this.cash_data.cashData.map(each => {
          if (parseFloat(each.value) > 0) {
            each.value = parseFloat(each.value).toFixed(2);
            return each;
          }
        }) || null
      );
    },
    ...mapGetters([
      "currencyPortfolio",
      "isCurrencyPortfolioLoading",
      "rate",
      "freeAmount",
      "blockedAmount",
      "totalAmount",
      "displayingCurrency",
      "currenciesOfUser",
      "currencySign",
      "balanceByCurrency",
      "getSelectedCurrency",
      "getMoneyDataLoading"
    ]),
    ...mapGetters({
      cash_data: "getMoneyDetailsFormatted",
      portfolio: "selectedPortfolio"
    })
  },
  methods: {
    fetchData() {
      this.$store.dispatch("fetchFinancialDetails").then(res => {
        let { moneyDetails } = res;
        (moneyDetails || []).forEach(each => {
          let free_amount = parseFloat(each.FREE_AMOUNT || null);
          if (free_amount < 0) {
            this.$toasted.error(
              "Отрицательная сумма свободных денежных средств: " +
                each.FREE_AMOUNT +
                " " +
                each.CURRENCY
            );
          }
        });
      });
    },
    formatMoney
  },
  mounted() {
    // if (this.currencyPortfolio === null) {
    //   this.$store.dispatch("fetchAccountData");
    // }
  }
};
</script>

<style scoped>
.cash-chart__preloader {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  z-index: 1000;
}

.heading {
  font-size: 36px;
  font-weight: normal;
  color: #222c44;
}

.cash-chart {
  position: relative;
  margin-top: 20px;
  width: 80%;
  height: 400px;
}

.cash-chart__chart {
  width: 100%;
}

.pie-chart {
  height: 100%;
  margin-top: 90px;
}

.cash-chart__total-balance {
  display: inline-block;
  margin-top: 30px;
  padding: 10px 15px;
  font-size: 20px;
  font-weight: normal;
  color: #ffffff;
  background-color: #2e79ef;
  border-radius: 10px;
}

@media (max-width: 1100px) {
  .cash-chart {
    width: 100%;
    margin: 20px auto 0;
  }
}
</style>
